import { render, staticRenderFns } from "./contactModal.vue?vue&type=template&id=0fc4e03c&scoped=true"
import script from "./contactModal.vue?vue&type=script&lang=js"
export * from "./contactModal.vue?vue&type=script&lang=js"
import style0 from "./contactModal.vue?vue&type=style&index=0&id=0fc4e03c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fc4e03c",
  null
  
)

export default component.exports